export default __webpack_public_path__ + "7ce97f44fcb5e088894bdaa35553af26.gif";